import React, { ReactNode, HTMLAttributes } from 'react';

interface PageWrapperProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
}

const PageWrapper: React.FC<PageWrapperProps> = ({ children, className = '', ...props }) => {
  return (
    <div
      className={`h-[calc(100vh-4.25rem)] w-full px-4 md:px-6 xl:px-7.5 rounded-2xl border border-stroke bg-white/90 shadow-card ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default PageWrapper;
